import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { GepjarmuService } from '../gepjarmu.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/*  GÉPJÁRMŰ – Sofőrök: a cég dolgozói vagy külsősök. A Bér dolgozójához köthető (a magánautós költségtérítés
 *  így a bérszámfejtésbe átadható), a szabadnapokat a havi útnyilvántartás-tervező kihagyja.
 *  Szerkesztési zár: gepjarmu_sofor. */
@Component({
  selector: 'app-gj-soforok',
  templateUrl: './soforok.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../gepjarmu-shared.scss'],
})
export class GjSoforokComponent implements OnInit, OnDestroy {
  soforok: any[] = [];
  dolgozok: any[] = [];
  kereso = '';
  inaktiv = false;
  betolt = false;
  szerk: any = null;
  ujNap = '';
  tartomany = { tol: '', ig: '' };
  zar: SzerkZar | null = null;
  ment = false;
  private zarKor = 0;
  private sub?: Subscription;

  constructor(public gj: GepjarmuService, private toast: ToastController, private alert: AlertController, private szerkZar: SzerkZarService) {}
  get u() { return this.gj.aktiv.ugyfelId; }
  get ir() { return this.gj.ir; }
  get zarolt() { return !!this.zar && !this.zar.irhato; }

  async ngOnInit() { await this.gj.init(); this.sub = this.gj.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); this.zarElenged(); }

  async frissit() {
    if (!this.u) { this.soforok = []; return; }
    this.betolt = true;
    try {
      this.soforok = await this.gj.get(`/soforok/${this.u}`);
      try { this.dolgozok = await this.gj.get(`/ber-dolgozok/${this.u}`); } catch { this.dolgozok = []; }
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni a sofőröket.'); }
    finally { this.betolt = false; }
  }
  get lathato(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return this.soforok.filter((s) => (this.inaktiv || s.aktiv) && (!k || [s.nev, s.adoazonosito, s.csoport, s.ber_nev].some((x) => String(x || '').toLowerCase().includes(k))));
  }
  get csoportok(): string[] { return [...new Set(this.soforok.map((s) => s.csoport).filter(Boolean))].sort(); }
  /*  A választható Bér-dolgozók: a még nem kötöttek és a sajátja. */
  get dolgozoLista(): any[] { return this.dolgozok.filter((d) => !d.sofor_id || d.sofor_id === this.szerk?.id); }
  jovoSzabadnap(s: any): number { const ma = new Date().toISOString().slice(0, 10); return (s.szabadnapok || []).filter((d: string) => d >= ma).length; }

  uj() {
    this.zarElenged();
    this.szerk = { id: null, nev: '', adoazonosito: '', lakcim: '', ber_alkalmazott_id: null, csoport: '', szabadnapok: [], aktiv: true, megjegyzes: '' };
  }
  nyit(s: any) { this.szerk = this.szerkAdat(s); this.zarFoglal(String(s.id)); }
  private szerkAdat(s: any) { return { ...s, szabadnapok: [...(s.szabadnapok || [])], aktiv: !!Number(s.aktiv), csoport: s.csoport || '', megjegyzes: s.megjegyzes || '' }; }
  private async zarFoglal(id: string) {
    this.zarElenged();
    if (!this.ir) return;
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('gepjarmu', 'gepjarmu_sofor', id, { ujratolt: () => this.ujratolt(id) });
    if (kor !== this.zarKor || String(this.szerk?.id) !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  bezar() { this.szerk = null; this.ujNap = ''; this.tartomany = { tol: '', ig: '' }; this.zarElenged(); }
  private async ujratolt(id: string) {
    this.soforok = await this.gj.get(`/soforok/${this.u}`);
    const s = this.soforok.find((x) => String(x.id) === id);
    if (s && String(this.szerk?.id) === id) this.szerk = this.szerkAdat(s);
  }
  /*  A Bér dolgozójának kiválasztásakor az üres mezők kitöltődnek az adataiból. */
  dolgozoValt(id: string | null) {
    this.szerk.ber_alkalmazott_id = id;
    const d = this.dolgozok.find((x) => x.id === id);
    if (!d) return;
    if (!this.szerk.nev) this.szerk.nev = d.nev;
    if (!this.szerk.adoazonosito && d.adoazonosito) this.szerk.adoazonosito = d.adoazonosito;
    if (!this.szerk.lakcim && d.lakcim) this.szerk.lakcim = d.lakcim;
  }

  /* ── szabadnapok ── */
  napHozzaad() {
    if (!this.ujNap) return;
    this.napokBe([this.ujNap]);
    this.ujNap = '';
  }
  tartomanyHozzaad() {
    const { tol, ig } = this.tartomany;
    if (!tol || !ig || ig < tol) { this.hiba('Adj meg érvényes időszakot (a vége nem lehet a kezdete előtt).'); return; }
    const napok: string[] = [];
    const d = new Date(`${tol}T00:00:00Z`); const veg = new Date(`${ig}T00:00:00Z`);
    while (d <= veg && napok.length < 120) {
      const hn = d.getUTCDay();
      if (hn !== 0 && hn !== 6) napok.push(d.toISOString().slice(0, 10));   // a hétvégét a tervező amúgy is kihagyja
      d.setUTCDate(d.getUTCDate() + 1);
    }
    if (d <= veg) { this.hiba('Egyszerre legfeljebb 120 nap vehető fel.'); return; }
    this.napokBe(napok);
    this.tartomany = { tol: '', ig: '' };
  }
  private napokBe(napok: string[]) { this.szerk.szabadnapok = [...new Set([...(this.szerk.szabadnapok || []), ...napok])].sort(); }
  napTorol(n: string) { this.szerk.szabadnapok = this.szerk.szabadnapok.filter((x: string) => x !== n); }
  get regiNapok(): number { const ma = new Date().toISOString().slice(0, 10); return (this.szerk?.szabadnapok || []).filter((d: string) => d < ma).length; }
  regiTorol() { const ma = new Date().toISOString().slice(0, 10); this.szerk.szabadnapok = this.szerk.szabadnapok.filter((d: string) => d >= ma); }

  async mentes() {
    if (this.zarolt || this.ment) return;
    const s = this.szerk;
    this.ment = true;
    try {
      if (s.id) await this.gj.put(`/sofor/${s.id}`, s); else await this.gj.post(`/sofor/${this.u}`, s);
      this.bezar(); this.ok('Sofőr mentve.'); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.ment = false; }
  }
  async torol() {
    if (this.zarolt || !this.szerk?.id) return;
    const s = this.szerk;
    const a = await this.alert.create({
      header: 'Sofőr törlése', message: `Biztosan törlöd: ${s.nev}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: () => { this.torolVeg(s.id); } }],
    });
    await a.present();
  }
  private async torolVeg(id: string) {
    try { await this.gj.del(`/sofor/${id}`); this.bezar(); this.ok('Sofőr törölve.'); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 5200, color: 'danger' })).present(); }
}
